import type { TextWidget } from '@/features/intelligence/dashboard/types';

/** Plain-text note. Blank lines split paragraphs; everything else is verbatim. */
export function TextWidgetView({ widget }: { widget: TextWidget }) {
  const paragraphs = widget.body.split(/\n{2,}/).filter((p) => p.trim().length > 0);
  if (paragraphs.length === 0) {
    return <p className="text-sm italic text-muted-foreground">Empty note — open the editor to add text.</p>;
  }
  return (
    <div className="h-full space-y-2 overflow-y-auto text-sm leading-relaxed text-foreground">
      {paragraphs.map((p, i) => (
        <p key={i} className="whitespace-pre-wrap">
          {p}
        </p>
      ))}
    </div>
  );
}
